<div class="common-card" [ngClass]="size" [class.fill-height]="fillHeight">
    <div class="common-card-header" *ngIf="title">{{ title }}</div>
    <div class="common-card-body" [class.spacer]="spacer">
        <ng-content select="[body]"></ng-content>
    </div>
</div>